// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import Faqs from './Faqs';

import { IRoute } from '../';

const Routes: IRoute[] = [
    {
        crumbText: 'faqs',
        component: Faqs,
        exact: true,
        path: '/faqs',
    },
];

export default Routes;